import { CloudStagingListController } from '../controller/CloudStagingListController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { CloudStagingListNirvanaDataProvider } from "../dataProvider/CloudStagingListNirvanaDataProvider";

export class CloudStagingListWebComponent extends BaseWebComponentElement {
  public controller!: CloudStagingListController;
  public dataProvider!: CloudStagingListNirvanaDataProvider;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CloudStagingListController,
    });
  }

  static override get observedAttributes(): string[] {
    return [...BaseWebComponentElement.observedAttributes, "data-company-id"];
  }

  override attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (CloudStagingListWebComponent.observedAttributes.indexOf(name) !== -1) {
      (this.controller as CloudStagingListController)?.render().then().catch();
    }
  }

}
